import { ScrollArea } from '@app/shared/ui/atoms/Common';
import { Footer, Form, Header } from '@app/shared/ui/organisms/Auth';
import { useLogin } from '@app/shared/hooks/useLogin';

export interface LoginFormSchema {
  email?: string;
  telegramId?: string;
  password: string;
}

export default function AuthPage() {
  const {
    handleLanguageChange,
    handleLoginSubmit,
    isLoggingIn,
    form,
    loginMethod,
    setLoginMethod,
  } = useLogin();

  return (
    <ScrollArea>
      <div className="flex flex-1 flex-col justify-center">
        <Header onLanguageChange={handleLanguageChange} />
        <Form
          onSubmit={handleLoginSubmit}
          isLoading={isLoggingIn}
          form={form}
          loginMethod={loginMethod}
          setLoginMethod={setLoginMethod}
        />
        <Footer />
      </div>
    </ScrollArea>
  );
}
